import { getOrderItems } from './get-order-items';
export const getOrderItemCount = () => getOrderItems().length;
